import React from "react";

function ConfirmationModal({ onConfirm, onCancel }) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Confirm Submission</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
              ></button>
            </div>
            <div className="modal-body">
              <p>
                Please ensure that you have fully entered and reviewed all the
                required information before proceeding. Double-check for any
                missing or incorrect details.
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={onConfirm}
              >
                Yes, Proceed
              </button>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default ConfirmationModal;
